var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalDashboardDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4.5,
    fill: "#1570EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4436 13.5547H23.3325C22.861 13.5547 22.4088 13.742 22.0754 14.0754C21.742 14.4088 21.5547 14.861 21.5547 15.3325V28.6658C21.5547 29.1373 21.742 29.5895 22.0754 29.9229C22.4088 30.2563 22.861 30.4436 23.3325 30.4436H30.4436C30.9151 30.4436 31.3673 30.2563 31.7007 29.9229C32.0341 29.5895 32.2214 29.1373 32.2214 28.6658V15.3325C32.2214 14.861 32.0341 14.4088 31.7007 14.0754C31.3673 13.742 30.9151 13.5547 30.4436 13.5547ZM30.4436 15.3325V25.1102H23.3325V15.3325H30.4436ZM23.3325 28.6658V26.5325H30.4436V28.6658H23.3325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 21.5547H5.55903V7.33247H26.8924V11.7769H28.6701V7.33247C28.6701 6.86097 28.4828 6.40878 28.1494 6.07539C27.816 5.74199 27.3639 5.55469 26.8924 5.55469H5.55903C5.08753 5.55469 4.63535 5.74199 4.30195 6.07539C3.96855 6.40878 3.78125 6.86097 3.78125 7.33247V21.5547C3.78125 22.0262 3.96855 22.4784 4.30195 22.8118C4.63535 23.1452 5.08753 23.3325 5.55903 23.3325H19.7812V21.5547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.776 25.1094H9.99826C9.76252 25.1094 9.53642 25.203 9.36972 25.3697C9.20303 25.5364 9.10938 25.7625 9.10938 25.9983C9.10938 26.234 9.20303 26.4601 9.36972 26.6268C9.53642 26.7935 9.76252 26.8872 9.99826 26.8872H19.776V25.1094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDashboardDevices);
export default __webpack_public_path__ + "static/media/TotalDashboardDevices.3f639a25adcf5e957e6db589a151d3c1.svg";
export { ForwardRef as ReactComponent };